module.exports = __webpack_public_path__ + "img/3.de655621.jpg";